<template lang="html">
  <div class="content">
    <h3 class="eco-invoice-title">
      Informações Gerais
    </h3>

    <div class="columns">
      <div class="column">
        <div class="field required">
          <label class="label">
            <abbr>* Tipo do CTe</abbr>
          </label>

          <div class="control">
            <span class="select is-medium is-fullwidth">
              <select v-model="cte.tpCTe">
                <option
                  v-for="(tpCTe, tpCTeIndex) in tpCTes"
                  :key="tpCTeIndex"
                  :value="tpCTe.value"
                >
                  {{ tpCTe.text }}
                </option>
              </select>
            </span>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field required">
          <label class="label">
            <abbr>* Tipo de Serviço</abbr>
          </label>

          <div class="control">
            <span class="select is-medium is-fullwidth">
              <select v-model="cte.tpServ">
                <option
                  v-for="(tpServ, tpServIndex) in tpServs"
                  :key="tpServIndex"
                  :value="tpServ.value"
                >
                  {{ tpServ.text }}
                </option>
              </select>
            </span>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <label
            class="label"
            for="cfop"
          >
            <abbr title="necessário">*</abbr>
            CFOP
          </label>
          <div class="control">
            <input
              id="cfop"
              v-model="cte.cfop"
              type="text"
              class="input is-medium"
            >
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field">
          <label
            class="label"
            for="natOp"
          >
            <abbr title="necessário">*</abbr>
            Natureza
          </label>
          <div class="control">
            <input
              id="natOp"
              v-model="cte.natOp"
              type="text"
              class="input is-medium"
            >
          </div>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <div class="field required">
          <label class="label">
            <abbr>* Tomador do Serviço</abbr>
          </label>

          <div class="control">
            <span class="select is-medium is-fullwidth">
              <select v-model="cte.taker_kind">
                <option
                  v-for="(taker_kind, takerKindIndex) in taker_kinds"
                  :key="takerKindIndex"
                  :value="taker_kind.value"
                >
                  {{ taker_kind.text }}
                </option>
              </select>
            </span>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field required">
          <label class="label">
            <abbr>* Remetente</abbr>
          </label>

          <div class="control">
            <span class="select is-medium is-fullwidth">
              <select v-model="cte.sender_id">
                <option
                  disabled
                  value=""
                >Selecione um remetente</option>
                <option
                  v-for="(customer, customerIndex) in customers"
                  :key="customerIndex"
                  :value="customer.id"
                >
                  {{ customer.name }} ({{ customer.cpf_cnpj }})
                </option>
              </select>
            </span>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field required">
          <label class="label">
            <abbr>* Destinatário</abbr>
          </label>

          <div class="control">
            <span class="select is-medium is-fullwidth">
              <select v-model="cte.receiver_id">
                <option
                  disabled
                  value=""
                >Selecione um destinatário</option>
                <option
                  v-for="(customer, customerIndex) in customers"
                  :key="customerIndex"
                  :value="customer.id"
                >
                  {{ customer.name }} ({{ customer.cpf_cnpj }})
                </option>
              </select>
            </span>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="field required">
          <label class="label">
            <abbr>Tomador</abbr>
          </label>

          <div class="control">
            <span class="select is-medium is-fullwidth">
              <select v-model="cte.taker_id">
                <option
                  disabled
                  value=""
                >Selecione um tomador</option>
                <option
                  v-for="(customer, customerIndex) in customers"
                  :key="customerIndex"
                  :value="customer.id"
                >
                  {{ customer.name }} ({{ customer.cpf_cnpj }})
                </option>
              </select>
            </span>
          </div>
        </div>
      </div>
    </div>

    <a
      class="button"
      @click.prevent="openCustomerModal()"
    >+ Novo Cliente</a>

    <modal
      v-if="isCustomerVisible"
      title="Novo cliente"
      :is-visible="isCustomerVisible"
      :close-modal="closeCustomerModal"
      :save-button="addCustomer"
    >
      <customer-form ref="customerForm" />
    </modal>
  </div>
</template>

<script>
import { http } from 'app/v1/src/plugins/http';
import { getData } from 'app/v1/src/utils/get';
import Modal from 'app/v1/src/components/Modal';
import CustomerForm from 'app/v1/src/Customer/New';

export default {

  components: {
    Modal,
    CustomerForm,
  },

  props: {
    cte: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      customers: [],
      isCustomerVisible: false,

      tpCTes: [
        { value: 0, text: 'Normal' },
        { value: 1, text: 'Complemento de Valores' },
        { value: 2, text: 'Anulação' },
        { value: 3, text: 'Substituição' },
      ],

      tpServs: [
        { value: 0, text: 'Normal' },
        { value: 1, text: 'Subcontratação' },
        { value: 2, text: 'Redespacho' },
        { value: 3, text: 'Redespacho Intermediário' },
      ],

      taker_kinds: [
        { value: 0, text: 'Remetente' },
        { value: 1, text: 'Expedidor' },
        { value: 2, text: 'Recebedor' },
        { value: 3, text: 'Destinatário' },
        { value: 4, text: 'Outros' },
      ]
    };
  },

  mounted() {
    this.setCustomers();
  },

  methods: {
    setCustomers() {
      http.get('/api/customers')
        .then(getData)
        .then(data => {
          this.customers = data;
        })
        .catch(() => Promise.reject('FAIL_IN_FETCH_CUSTOMERS'));
    },

    addCustomer() {
      this.$refs.customerForm.handleSubmit()
        .then((data) => {
          this.customers.push(data);
          this.closeCustomerModal();
        })
        .catch(() => Promise.reject('FAIL_IN_ADD_CUSTOMER'));
    },

    openCustomerModal() {
      this.isCustomerVisible = true;
    },

    closeCustomerModal() {
      this.isCustomerVisible = false;
    },
  }
};
</script>
